<template>
  <BModal
    id="modal-extend-invoice"
    :model-value="modal"
    scrollable
    centered
    title="Extend Invoice"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5>Extend Stay Invoice</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <div class="guest-info text-start" id="extendPrintArea">
      <!-- Kop & Logo (Print Only) -->
      <div class="print-only" style="text-align: center; margin: 0; padding: 0">
        <table class="w-full border-collapse" style="width: 100%; border-collapse: collapse">
          <tbody style="padding: 0; margin: 0">
            <tr class="border-b border-transparent">
              <td class="text-center" style="text-align: center">
                <img
                  src="../../../public/img/hotel-deliriver.png"
                  alt="Deli River Hotel Logo"
                  style="width: 50px; height: auto"
                />
              </td>
            </tr>
            <tr class="border-b border-transparent" style="padding: 0px; margin: 0px">
              <td class="text-center">
                <h3 class="text-center">Deli River Hotel</h3>
                <p class="text-center">
                  Jl. Raya Namorambe No. 129, Medan, Indonesia
                </p>
                <p class="text-center">www.hotel-deliriver.com</p>
                <p class="text-center">contact@hotel-deliriver.com</p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <p class="text-center"><strong>Extend Stay Invoice</strong></p>
      </div>

      <!-- Guest Information -->
      <div>
        <p class="text-secondary fw-semibold">Guest Information</p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left" style="width: 130px">Date</td>
              <td class="text-left" style="width: 15px">:</td>
              <td class="text-left fw-semibold">
                {{ formattedToday }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Booking Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ resData?.number || resData?.booking_number || "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Guest Name</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ resData?.guest?.fullname || resData?.guest?.name || "-" }}
              </td>
            </tr>
            <tr class="border-b border-transparent">
              <td class="text-left">Booking Source</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ resData?.source?.type || "-" }} - {{ resData?.source?.name || "-" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />

      <!-- Table View (Print & Screen) -->
      <div>
        <table
          class="w-full border-collapse"
          style="width: 100%; border-collapse: collapse; font-size: 14px"
        >
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 6px">Room</th>
              <th style="border: 1px solid #000; padding: 6px">Extension Period</th>
              <th style="border: 1px solid #000; padding: 6px" class="text-center">Nights</th>
              <th style="border: 1px solid #000; padding: 6px" class="text-end">Rate / Night</th>
              <th style="border: 1px solid #000; padding: 6px" class="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #000; padding: 6px">
                {{ resData?.room?.room_category?.name || "Room" }} ({{ resData?.room?.code || "-" }})
              </td>
              <td style="border: 1px solid #000; padding: 6px">
                {{ periodText }}
              </td>
              <td style="border: 1px solid #000; padding: 6px" class="text-center">
                {{ extendNights }}
              </td>
              <td style="border: 1px solid #000; padding: 6px" class="text-end">
                {{ formatIDR(extendRate) }}
              </td>
              <td style="border: 1px solid #000; padding: 6px" class="text-end">
                {{ formatIDR(extendTotal) }}
              </td>
            </tr>

            <!-- TOTAL EXTEND -->
            <tr style="font-weight: bold">
              <td colspan="4" style="border: 1px solid #000; padding: 6px; text-align: right">
                Total Extend Cost :
              </td>
              <td style="border: 1px solid #000; padding: 6px" class="text-end">
                {{ formatIDR(extendTotal) }}
              </td>
            </tr>

            <!-- PAID AMOUNT -->
            <tr style="font-weight: bold">
              <td colspan="4" style="border: 1px solid #000; padding: 6px; text-align: right">
                Paid Amount :
              </td>
              <td style="border: 1px solid #000; padding: 6px" class="text-end">
                {{ formatIDR(extendPaid) }}
              </td>
            </tr>

            <!-- REST PAYMENT -->
            <tr style="font-weight: bold">
              <td colspan="4" style="border: 1px solid #000; padding: 6px; text-align: right">
                Remaining Balance :
              </td>
              <td
                style="border: 1px solid #000; padding: 6px"
                class="text-end"
                :style="{ color: extendRemaining > 0 ? 'red' : 'inherit' }"
              >
                {{ formatIDR(extendRemaining) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Payment Method Info (Print Only) -->
      <div class="print-only mt-4" v-if="paymentMethodName">
        <br />
        <p class="text-secondary fw-italic">Payment Information :</p>
        <table class="w-full text-left border-collapse">
          <tbody>
            <tr class="border-b border-transparent">
              <td class="text-left" style="width: 150px">Payment Method</td>
              <td class="text-left" style="width: 15px">:</td>
              <td class="text-left fw-semibold">
                {{ paymentMethodName }}
              </td>
            </tr>
            <tr class="border-b border-transparent" v-if="paymentMethodNumber">
              <td class="text-left">Account Number</td>
              <td class="text-left">:</td>
              <td class="text-left fw-semibold">
                {{ paymentMethodNumber }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <br />
      <!-- Signature Section (Print Only) -->
      <div class="print-only mt-4" style="text-align: center; margin: 0; padding: 0">
        <div>
          <p><strong>Reservation Dept.</strong></p>
          <br /><br /><br />
          <p>{{ cashierName }}</p>
          <p>______________________</p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="warning" class="mr-2" @click="handlePrint">
          <i class="fas fa-print mr-1"></i> Print
        </BButton>
        <BButton variant="danger" @click="updateModal(false)">Close</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import { computed } from "vue";
import { BModal, BButton } from "bootstrap-vue-next";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

export default {
  name: "ExtendInvoiceModal",
  components: {
    BModal,
    BButton,
  },
  props: {
    modal: Boolean,
    item: Object,
    extendInfo: Object,
  },
  emits: ["update:modal"],
  setup(props, { emit }) {
    const updateModal = (value) => {
      emit("update:modal", value);
    };

    const rawData = computed(() => {
      return props.item?.item || props.item || {};
    });

    const resData = computed(() => {
      return rawData.value?.reservation || rawData.value || {};
    });

    const formattedToday = computed(() => {
      try {
        return getFormattedDate(new Date());
      } catch (e) {
        return new Date().toLocaleDateString("id-ID");
      }
    });

    const cashierName = computed(() => {
      const stored = localStorage.getItem("user");
      if (stored) {
        try {
          const user = JSON.parse(stored);
          return user.fullname || user.name || "Receptionist";
        } catch (e) {
          console.error(e);
        }
      }
      return "Reservation Dept.";
    });

    const extendNights = computed(() => {
      if (props.extendInfo?.additional_days) {
        return Number(props.extendInfo.additional_days);
      }
      return 1;
    });

    const extendRate = computed(() => {
      if (props.extendInfo?.room_price) {
        return Number(props.extendInfo.room_price);
      }
      return Number(resData.value?.room_price || 0);
    });

    const extendTotal = computed(() => {
      if (props.extendInfo?.extend_cost) {
        return Number(props.extendInfo.extend_cost);
      }
      return extendNights.value * extendRate.value;
    });

    const extendPaid = computed(() => {
      if (typeof props.extendInfo?.payment_amount !== "undefined") {
        return Number(props.extendInfo.payment_amount);
      }
      // Fallback: jika reservasi full payment
      if (resData.value?.payment_status === "Full Payment") {
        return extendTotal.value;
      }
      return 0;
    });

    const extendRemaining = computed(() => {
      return Math.max(0, extendTotal.value - extendPaid.value);
    });

    const periodText = computed(() => {
      if (props.extendInfo?.new_end_date) {
        return `Until ${dateFormatter(props.extendInfo.new_end_date)}`;
      }
      if (rawData.value?.check_out_date || resData.value?.end) {
        return `Until ${dateFormatter(rawData.value?.check_out_date || resData.value?.end)}`;
      }
      return "-";
    });

    const paymentMethodName = computed(() => {
      return (
        resData.value?.payment_method?.name ||
        resData.value?.payment_method?.type ||
        ""
      );
    });

    const paymentMethodNumber = computed(() => {
      return resData.value?.payment_method?.number || "";
    });

    const handlePrint = () => {
      const printContents = document.getElementById("extendPrintArea")?.innerHTML;
      if (!printContents) return;

      const bookingNumber = resData.value?.number || "EXT";
      const now = new Date();
      const pad = (num) => String(num).padStart(2, "0");
      const formattedDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}`;
      const filename = `invoice-EXT-${bookingNumber}-${formattedDate}`;

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.setAttribute("sandbox", "allow-modals allow-same-origin allow-scripts");
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${filename}</title>
            <meta name="viewport" content="width=device-width,initial-scale=1.0">
            <style>
              @media print {
                @page {
                  size: 80mm auto;    
                }
                body {
                  font-family: sans-serif;
                  font-size: 14px;
                  margin: 10px;
                  padding: 0;
                }
                h2, h3, h4 {
                  margin: 0;
                }
                p {
                  margin: 3px 0px;
                }
                hr {
                  margin-top: -5px;
                }
                tbody {
                  margin: 0px;
                }
                .text-center { text-align: center; }
                .text-left { text-align: left; }
                .text-end { text-align: right; }
              }
            </style>
          </head>
          <body>
            ${printContents}
          </body>
        </html>
      `);
      doc.close();

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 1000);
      };
    };

    return {
      updateModal,
      rawData,
      resData,
      formattedToday,
      cashierName,
      extendNights,
      extendRate,
      extendTotal,
      extendPaid,
      extendRemaining,
      periodText,
      paymentMethodName,
      paymentMethodNumber,
      handlePrint,
      formatIDR,
      dateFormatter,
    };
  },
};
</script>

<style scoped>
@media screen {
  .print-only {
    display: none;
  }
}
</style>
